import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

import { ConfirmDialog } from "@/components/ConfirmDialog";
import { refetchQueries } from "@/utils";
import { removeBlog } from "@/services/blog";
import { configs } from "@/configs";

import type { AxiosErrorWithData } from "@/client/api";

export type RemoveBlogDialogProps = {
  open: boolean;
  onClose: (reason: "success" | "cancel") => void;
  id: string;
  fetchKeys?: string[];
};

export function RemoveBlogDialog({
  open: isOpen,
  onClose,
  id,
  fetchKeys = [],
}: RemoveBlogDialogProps) {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { mutate: remove, isLoading } = useMutation(removeBlog, {
    onSuccess: async () => {
      enqueueSnackbar("ลบ สำเร็จ", { variant: "success" });
      await refetchQueries({ queryClient, fetchKeys });
      onClose("success");
    },
    onError: (error: AxiosErrorWithData) => {
      console.error(error);
      enqueueSnackbar(
        error.response?.data.message ?? configs.unknownErrorMessage,
        { variant: "error" }
      );
    },
  });

  const onConfirm = () => remove(id);

  return (
    <ConfirmDialog
      maxWidth="xs"
      open={isOpen}
      onClose={() => onClose("cancel")}
      onConfirm={onConfirm}
      title="คุณต้องการลบหรือไม่"
      confirmMessage="ลบ"
      loading={isLoading}
    />
  );
}
